// 机构详情接口
import states from '../state/pageCompany'
import mutations from '../mutations/pageCompany'
import actions from '../actions/pageCompany'
import getters from '../getters/pageCompany';


export default {
  namespaced: true,
  states,
  mutations,
  actions,
  getters
}